export default __webpack_public_path__ + "static/media/E-commerce-gif1.925b2985.gif";